module.exports = __webpack_public_path__ + "img/csm__MG_8371_9bd8af32ea.cedbf38f.jpg";